module.exports = __webpack_public_path__ + "img/sieckFinesseSetup6.684aa1bb.png";